import { Fragment } from "react";
import { clsx } from "@/utils";
import { OPERATOR_EMAIL_PLACEHOLDER, RichText } from "../data/driverAppScenarios";

/** The owner account can be absent while it loads, or if no account carries the "Owner" role. */
const EMAIL_FALLBACK = "your web portal login email";

export interface ScenarioCopyProps {
  runs: RichText;
  /** Substituted for the "[operator email]" placeholder in the Figma copy. */
  operatorEmail?: string;
}

/**
 * Renders one line of Scenario copy. The data file keeps emphasis as runs rather than markup so the
 * copy stays editable without touching JSX.
 */
export const ScenarioCopy = ({ runs, operatorEmail }: ScenarioCopyProps) => (
  <>
    {runs.map((run, index) => {
      const { text, bold, underline } = typeof run === "string" ? { text: run, bold: false, underline: false } : run;
      const resolved = text.replaceAll(OPERATOR_EMAIL_PLACEHOLDER, operatorEmail || EMAIL_FALLBACK);

      if (!bold && !underline) return <Fragment key={index}>{resolved}</Fragment>;

      return (
        <span key={index} className={clsx(bold && "font-semibold", underline && "underline")}>
          {resolved}
        </span>
      );
    })}
  </>
);
